<div class="general-popup-content">
  <div class="modal-content">
    <div class="game-title">Learn {{ guide.fetchGame }}</div>
    <div class="navigation-wrap full-width">
      <a class="navigation-link" *ngFor="let tab of tabs; let i = index"
         [class.--current]="tab === selectedTab"
         (click)="selectedTab = tab">
        <div>{{ tab }}</div>
      </a>
    </div>

    <ng-container *ngIf="selectedTab === 'gameplay'">
        <div class="slider">
            <div class="slider-controls">
                <div class="arrow-left" *ngIf="selectedIndex > 0"><div class="arrow-icon" (click)="left()"><i class="fal fa-chevron-left" ></i></div></div>
                <div class="arrow-right" *ngIf="selectedIndex < sections.length - 1"><div class="arrow-icon" (click)="right()"><i class="fal fa-chevron-right" ></i></div></div>
            </div>
            <div class="box" [ngStyle]="{transform: 'translateX(-' + 100 * selectedIndex + '%)'}">

                <ng-container *ngIf="!!sections">
                    <div *ngFor="let section of sections" class="section">
                        <img class="slide-img" [src]="section.imgPath">
                        <div class="section-title">
                            {{ section.title }}
                        </div>
                        <div class="section-text">
                            {{ section.text }}
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="selectedTab === 'rules'">
        <div class="rules">
            Rules
        </div>
    </ng-container>


    <div class="button-place">
      <app-form-button class="primary" (click)="router.navigate(['/', {outlets: { modal: null } } ])">Play <i class="fal fa-chevron-right" ></i></app-form-button>
      <div class="stop-show" (click)="stopShow()">I don't want to see this modal again</div>
    </div>
  </div>

  <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup">
    <i class="fal fa-times"></i>
  </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/game-rules/game-rules-modal.component.html